export enum IPageObjectTypes {
    SHAPE = "SHAPE",
    PICTURE = "PICTURE",
    GROUP_SHAPE = "GROUP_SHAPE",
    CONNECTION_SHAPE = "CONNECTION_SHAPE",
}
